import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/api/client'

interface ConfigPayload {
  present: boolean
  path?: string
  data?: any
}

export function ProjectConfig() {
  const q = useQuery({
    queryKey: ['config'],
    queryFn: async () => (await apiFetch<ConfigPayload>('/api/config')).data,
  })

  if (q.isLoading) return <div className="page"><p>Loading…</p></div>
  const data = q.data

  return (
    <div className="page">
      <div className="page-head">
        <div><h1>Project config</h1><p>Read-only view of the project YAML the bridge loads. Changes happen in the repo, not here.</p></div>
      </div>
      {!data?.present ? (
        <div className="empty">
          <p>No project config mounted at <span className="mono">{data?.path || 'configured path'}</span>.</p>
        </div>
      ) : (
        <div className="card pad">
          <div className="muted" style={{ fontSize: 'var(--fs-200)', marginBottom: 'var(--sp-8)' }}>
            <span className="mono">{data.path}</span>
          </div>
          <pre className="mono" style={{
            fontSize: 'var(--fs-200)', background: 'var(--bg-inset)',
            padding: 'var(--sp-12)', borderRadius: 'var(--radius-md)',
            maxHeight: 480, overflow: 'auto', margin: 0,
          }}>{JSON.stringify(data.data, null, 2)}</pre>
        </div>
      )}
    </div>
  )
}
